import React from "react";
import { Button, Segment } from "semantic-ui-react";
import { RoomModal } from "./RoomModal";
import { TableWithPagination } from "../../components/TableView/TableWithPagination";
import { LOADING } from "../../utils/helpers/phases";
export const RoomsComponent = props => {
  return (
    <Segment
      basic
      loading={
        props.roomsPhase === LOADING || props.roomGroupsPhase === LOADING
      }>
      {props.isAdmin && !props.isKWHotelUser ? (
        <React.Fragment>
          <RoomModal initialValues={{ ...props.selected }} {...props} />
          <Button color="orange" onClick={() => props.toggleModal()}>
            {props.t("room:addRoomButton")}
          </Button>
        </React.Fragment>
      ) : (
        undefined
      )}
      {props.isAdmin &&
        props.isKWHotelUser && (
          <Button color="orange" onClick={props.syncRoomGroupsAndRooms}>
            {props.t("synchronization:synchronizeButton")}
          </Button>
        )}

      <TableWithPagination
        headers={[
          { label: props.t("room:nameText"), key: "name" },
          { label: props.t("room:roomTypeText"), key: "roomGroup" }
        ]}
        data={props.rooms.map(room => ({
          ...room,
          roomGroup:
            props.roomGroups.find(
              roomGroup => roomGroup.roomGroupId === room.roomGroupId
            ).name || ""
        }))}
        handleEditClick={room => props.toggleModal(room)}
        handleRemoveClick={({ roomId }) => props.removeRoom(roomId)}
        showActionButtons={props.isAdmin && !props.isKWHotelUser}
      />
    </Segment>
  );
};



// WEBPACK FOOTER //
// ./src/rooms/RoomsList/RoomsComponent.js